import React from "react";
import styled, { css } from "styled-components";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import { paddleCheckout } from "../../utils/paddleCheckout";
import { Select } from "antd";
import moment from "moment";

import SubscribePluginModal from "../ui/SubscribePluginModal";
import TermsGate from "../legal/TermsGate";
import SlugPicker from "./SlugPicker";
import Notify from "../ui/Notify";

import {
  getPlugins,
  getPluginSubscriptions,
  subscribePlugin,
  updatePaymentMethodSubscription,
  updatePaymentMethodSubscriptionDone,
  cancelPluginSubscription,
  setShowManagePluginModal,
  provisionSpectrePOS,
} from "./plugin.redux";

import { settingsHandleForm } from "../settings/settings.redux.js";

import { handleOpenCustomerPortal } from "../login/userSession.redux";
import { ModalManagePlugin } from "../modal/ModalManagePlugin";
import ProvisioningProgress from "./ProvisioningProgress";
import StorefrontLinks from "./StorefrontLinks";
import { Segmented, SegButton } from "../ui/Segmented";

const SquareHorizontal = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d4d4d5;
  border-radius: 40px;
  opacity: 1;
  padding: 1rem;
  box-sizing: border-box;
  min-width: 0;
`;

const Title = styled.h1`
  text-align: left;
  font: normal normal 600 20px/24px Poppins;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 0;
`;

const Subtitles = styled.h1`
  text-align: right;
  font: normal normal 600 12px/18px Poppins;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 0;

  ${(props) =>
    props.price &&
    css`
      font: normal normal 600 18px/24px Poppins;
    `}
`;

const Section = styled.div`
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  opacity: 1;
  width: 95%;
  margin-right: 2.5%;
  margin-left: 2.5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  ${(props) =>
    props.primary &&
    css`
      width: auto;
    `}
  ${(props) =>
    props.big &&
    css`
      width: auto;
    `}
`;
const DescriptionText = styled.span`
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) 10px / var(--unnamed-line-spacing-36)
    var(--unnamed-font-family-poppins);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-707070);
  text-align: center;
  font: normal normal normal 14px/36px Poppins;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  display: flex;
  line-height: 1.5;
  justify-content: center;
  margin-bottom: 1.8vh;
`;

const ButtonSubscribe = styled.button`
  display: inline-block;
  margin: 0.5rem 5px;
  width: 115px;
  height: 38px;
  background: #ffffff;
  color: #35991a;
  font: normal normal 600 16px/20px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;
  text-transform: uppercase;
  border-radius: 25px;
  border: 2px solid #35991a;

  ${(props) =>
    !props.active &&
    css`
      background: #35991a;
      color: #ffffff;
      border: none;
    `}

  ${(props) =>
    props.update &&
    css`
      background: #4a93e9;
      border: none;
    `}

    ${(props) =>
    props.cancel &&
    css`
      background: red;
    `}
`;

const Button = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  width: 52px;
  height: 55px;
  background: ${(props) => (props.active === true ? "#00297A" : "#E0E1E2")};
  color: ${(props) => (props.active === true ? "#FFFFFF" : "#00000099")};
  border: 2px solid white;
  font: normal normal 600 12px/18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;
  text-transform: uppercase;

  ${(props) =>
    props.primary &&
    css`
      padding: 0.5rem 1.5rem;
      margin: 0.5rem 1rem;
      border-radius: 7px;
      width: 110px;
      font: normal normal 600 32px var(--unnamed-font-family-poppins);
      font-weight: 700;
      color: #ffffff;
      opacity: 1;
      letter-spacing: 0px;

      @media only screen and (max-width: 900px) and (orientation: portrait) {
        text-align: center;
        font: normal normal 600 32px/48px Poppins;
        width: 70px;
        padding: 0;
      }
      @media only screen and (max-width: 450px) and (orientation: portrait) {
        padding: 0;
        margin: 0;
        width: 68px;
      }
    `}
  ${(props) =>
    props.left &&
    css`
      border-radius: 8px 0px 0px 8px;
      margin: 0.5rem 0;
    `}
    ${(props) =>
    props.right &&
    css`
      border-radius: 0px 8px 8px 0px;
      margin: 0.5rem 0.01rem;
      width: 53px;
    `}
    ${(props) =>
    props.reduceSize &&
    css`
      font: var(--unnamed-font-style-normal) normal 600
        var(--unnamed-font-size-12) / 15px var(--unnamed-font-family-poppins);
      font: normal normal 600 11px/15px Poppins;
    `}
    
    &:hover {
    background: #00187e;
    color: #ffffff;
  }
`;

const SectionLinkGuide = styled.div`
  margin-top: 7.5%;
  margin-right: 2.5%;
  margin-left: 2.5%;
`;

const pluginContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "0 0 2vh 0",
};

// Cards wrap onto new rows instead of scrolling sideways: a mouse wheel on
// macOS can't scroll horizontally and the hidden scrollbar gives no hint.
const PluginGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(260px, 100%), 1fr));
  gap: 1rem;
  padding: 1rem 0;
  width: 100%;
`;

const dropdownStyle = {
  width: "100%",
  height: 48,
  color: "#00197B",
};

const PluginList = (props) => {
  // Refresh subscriptions on every mount so navigating back to Settings
  // picks up out-of-band changes (cancellation via Paddle/Stripe customer
  // portal, status flips from the billing webhook, etc.). AppRouter only
  // fetches once per session when subscriptionInfo first loads.
  React.useEffect(() => {
    props.getPluginSubscriptions();
  }, []);

  const [showSubscribePluginModal, setShowSubscribePluginModal] =
    React.useState(false);

  const [pluginType, setPluginType] = React.useState("");
  const [priceId, setPriceId] = React.useState("");
  const [pluginForModal, setPluginForModal] = React.useState(null);
  // The price chosen on each plugin card, keyed by plugin id. It used to be
  // a local variable inside the render loop, so the picker never showed
  // the choice and any re-render dropped it before checkout.
  const [selectedPriceIds, setSelectedPriceIds] = React.useState({});
  // Tracks the pluginType currently going through Paddle checkout, so the
  // subscribe button can be replaced with a disabled "Activating..." state
  // during the gap between Paddle completing and redux confirming the
  // subscription. Prevents the user from accidentally double-paying while
  // pluginSubscriptions / provisionStatus are still catching up.
  const [activatingPluginType, setActivatingPluginType] = React.useState(null);
  // Paddle fires both `checkout.completed` and `checkout.closed` on a
  // successful payment. Without this ref, the onClose handler would clear
  // activatingPluginType immediately after onComplete set it, exposing the
  // subscribe button during the lag before redux catches up.
  const checkoutCompletedRef = React.useRef(false);

  // The purchase waiting on the customer accepting the terms, and the module
  // it is for. Held in a ref rather than state because storing a function in
  // useState means React calls it as a lazy initialiser and the purchase
  // fires the moment you try to park it.
  const pendingPurchaseRef = React.useRef(null);
  const [termsModuleCode, setTermsModuleCode] = React.useState(null);
  const [showTermsGate, setShowTermsGate] = React.useState(false);

  /**
   * Put the terms in front of a purchase. `proceed` runs only after the
   * acceptance has been recorded server-side; if the customer backs out or the
   * recording fails, it never runs at all.
   */
  const requireTerms = React.useCallback((moduleCode, proceed) => {
    pendingPurchaseRef.current = proceed;
    setTermsModuleCode(moduleCode || null);
    setShowTermsGate(true);
  }, []);

  // Once SpectrePOS is paid for, the owner picks the shop's web address and
  // the shop is created with it. SlugPicker hands straight back when new shops
  // are not on Chentro (or the shop exists), so this always ends in a
  // provision. Closed without choosing, the card offers it again.
  const pendingSlugRef = React.useRef(null);
  const [showSlugPicker, setShowSlugPicker] = React.useState(false);
  const { provisionSpectrePOS } = props;
  const setUpPosShop = React.useCallback(() => {
    pendingSlugRef.current = () => provisionSpectrePOS();
    setShowSlugPicker(true);
  }, [provisionSpectrePOS]);

  const { t } = useTranslation();
  const navigate = useNavigate();

  // Clear activatingPluginType once redux confirms the subscription showed up
  // (either via pluginSubscriptions array or, for SPECTRE_POS, via the
  // provisionStatus signal kicked off by provisionSpectrePOS()).
  React.useEffect(() => {
    if (!activatingPluginType) return;
    const confirmed =
      props.pluginSubscriptions.indexOf(activatingPluginType) !== -1 ||
      (activatingPluginType === "SPECTRE_POS" && props.provisionStatus);
    if (confirmed) setActivatingPluginType(null);
  }, [
    activatingPluginType,
    props.pluginSubscriptions,
    props.provisionStatus,
  ]);

  // Safety net: if Paddle silently fails (onClose/onComplete never fire) or
  // the user closes the tab and reopens, don't lock the button forever.
  React.useEffect(() => {
    if (!activatingPluginType) return;
    const timer = setTimeout(() => setActivatingPluginType(null), 60000);
    return () => clearTimeout(timer);
  }, [activatingPluginType]);

  const {
    isPaddleSubscription,
    isCAD,
    customerId,
    address_id,
    isSandbox,
    getPluginSubscriptions,
    pluginSubscriptionsData,
    setShowManagePluginModal,
    updatePaymentMethodSubscription,
    updatePaymentMethodSubscriptionDone,
    cancelPluginSubscription,
    settingsHandleForm,
    initialValues,
    updating,
    canceling,
    locale,
    spectreUserId,
  } = props;

  const getPluginSubscriptionData = (price) => {
    const plugins = pluginSubscriptionsData?.filter(
      (sub) => sub.items[0]?.price.id === price?.id,
    );

    return plugins.length > 0 ? plugins[0] : null;
  };

  return props.loading ? (
    <UpdatingSpinner />
  ) : (
    <PluginGrid>
      {isPaddleSubscription
        ? props.plugins.map((plugin) => {
            // Shortest term first, whatever order Paddle lists them in.
            const termOrder = { day: 0, week: 1, month: 2, year: 3 };
            const prices = [...(plugin?.prices || [])].sort(
              (a, b) =>
                (termOrder[a.billing_cycle?.interval] ?? 9) -
                (termOrder[b.billing_cycle?.interval] ?? 9),
            );
            // Something is always chosen: monthly when the plugin has it —
            // the smallest commitment — and the customer can switch.
            const selectedPrice =
              prices.find((price) => price.id === selectedPriceIds[plugin.id]) ||
              prices.find((price) => price.billing_cycle?.interval === "month") ||
              prices[0] ||
              null;
            const pluginType = (plugin.metadata || plugin.custom_data).pluginType;
            const isSubscribed =
              props.pluginSubscriptions.indexOf(pluginType) !== -1;
            const isPosProvisioning =
              pluginType === "SPECTRE_POS" &&
              props.provisionStatus &&
              props.provisionStatus !== "ready" &&
              props.provisionStatus !== "error";
            // After the progress: a failure keeps the stepper (it carries the
            // retry), and a Chentro shop that is ready keeps its way in.
            const showPosProgress =
              pluginType === "SPECTRE_POS" &&
              (isPosProvisioning ||
                props.provisionStatus === "error" ||
                (props.provisionStatus === "ready" &&
                  props.provisionBackend === "hbs"));
            const isActivating = activatingPluginType === pluginType;
            // Paid, but no shop yet: the address was never chosen (tab closed,
            // picker cancelled). A WordPress shop has its API url instead.
            const needsPosSetup =
              pluginType === "SPECTRE_POS" &&
              isSubscribed &&
              !props.provisionStatus &&
              !props.posApiUrl;
            const showSubscribeUI =
              !isSubscribed && !isPosProvisioning && !isActivating;
            return (
              <SquareHorizontal>
                <div style={pluginContainerStyle}>
                  <Section key={plugin.id}>
                    <Title>
                      {t((plugin.metadata || plugin.custom_data)[`Key_Title`])}
                    </Title>
                    <div style={{ fontSize: "12px", textAlign: "left" }}>
                      {t(
                        (plugin.metadata || plugin.custom_data)[
                          `Key_Description`
                        ],
                      )}
                    </div>
                    {showSubscribeUI && prices.length > 0 && (
                      <Segmented
                        $fill
                        role="group"
                        aria-label={t("form.label.pricing")}
                        style={{ marginTop: "10px" }}
                      >
                        {prices.map((price) => {
                          const isSelected = selectedPrice?.id === price.id;
                          return (
                            <SegButton
                              key={price.id}
                              type="button"
                              $active={isSelected}
                              aria-pressed={isSelected}
                              onClick={() =>
                                setSelectedPriceIds((current) => ({
                                  ...current,
                                  [plugin.id]: price.id,
                                }))
                              }
                            >
                              {t(
                                `form.label.${price.billing_cycle?.interval?.toUpperCase()}`,
                              )}
                            </SegButton>
                          );
                        })}
                      </Segmented>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {isActivating && (
                        <ButtonSubscribe
                          style={{
                            width: "245px",
                            marginLeft: "0px",
                            opacity: 0.6,
                            cursor: "default",
                          }}
                          disabled
                        >
                          {t("form.setting.activating", "Activating…")}
                        </ButtonSubscribe>
                      )}
                      {showSubscribeUI && (
                        <ButtonSubscribe
                          style={{
                            width: "245px",
                            marginLeft: "0px",
                            opacity: selectedPrice ? 1 : 0.5,
                            cursor: selectedPrice ? "pointer" : "default",
                          }}
                          disabled={!selectedPrice}
                          onClick={() => {
                            if (!selectedPrice) return;
                            if (
                              props.pluginSubscriptions.indexOf(
                                (plugin.metadata || plugin.custom_data)
                                  .pluginType,
                              ) === -1
                            ) {
                              if (
                                (plugin.metadata || plugin.custom_data)
                                  .pluginType === "SPECTRE_POS"
                              ) {
                                // Gate: SpectrePOS provision pushes the
                                // proshop address into WooCommerce as the
                                // store base address (drives tax). Block
                                // checkout if the structured fields aren't
                                // filled in yet.
                                const missing = [];
                                if (!props.proshopAddress) missing.push("address");
                                if (!props.proshopCity) missing.push("city");
                                if (!props.proshopState) missing.push("state");
                                if (!props.proshopPostalCode)
                                  missing.push("postal_code");
                                if (!props.proshopCountry)
                                  missing.push("country");
                                if (missing.length) {
                                  Notify(
                                    t("spectrepos.address_required"),
                                    "warning",
                                    8000,
                                  );
                                  navigate("/profile");
                                  return;
                                }
                                console.log(
                                  "SPECTRE_POS plugin is being subscribed to",
                                );
                                settingsHandleForm({
                                  appSettings: {
                                    ...initialValues,
                                    bowlerPreferences: {
                                      require_email: true,
                                      require_phone: true,
                                    },
                                  },
                                });
                              }
                              const checkoutPluginType = (
                                plugin.metadata || plugin.custom_data
                              ).pluginType;
                              // Terms first. requireTerms holds the purchase
                              // until the acceptance is recorded server-side,
                              // and drops it if that fails — a live
                              // subscription with no accepted terms behind it
                              // is the thing this gate exists to prevent.
                              requireTerms(checkoutPluginType, () => {
                              checkoutCompletedRef.current = false;
                              setActivatingPluginType(checkoutPluginType);
                              paddleCheckout({
                                items: [
                                  {
                                    priceId: selectedPrice?.id,
                                    quantity: 1,
                                  },
                                ],
                                customer: {
                                  id: customerId,
                                  address: {
                                    id: address_id,
                                  },
                                },
                                customData: {
                                  isPlugin: true,
                                  pluginType: checkoutPluginType,
                                  moduleCode: checkoutPluginType,
                                },
                                spectreUserId,
                                settings: {
                                  locale,
                                },
                                onComplete: (event) => {
                                  // Keep activatingPluginType set — the
                                  // useEffect above clears it once redux
                                  // confirms the subscription. This bridges
                                  // the lag between Paddle closing and the
                                  // banner updating.
                                  checkoutCompletedRef.current = true;
                                  getPluginSubscriptions();
                                  if (
                                    checkoutPluginType === "SPECTRE_POS"
                                  ) {
                                    setUpPosShop();
                                  } else {
                                    window.location.reload();
                                  }
                                },
                                onClose: () => {
                                  // Paddle fires `closed` AFTER `completed`
                                  // on a successful payment too. Only clear
                                  // activatingPluginType when this close
                                  // happens without a prior completion (i.e.
                                  // user bailed out).
                                  if (!checkoutCompletedRef.current) {
                                    setActivatingPluginType(null);
                                  }
                                },
                                isSandbox,
                              });
                              });
                            }
                          }}
                          value="true"
                          active={
                            props.pluginSubscriptions.indexOf(
                              (plugin.metadata || plugin.custom_data)
                                .pluginType,
                            ) === -1
                          }
                        >
                          {t("form.setting.add_subscription")}
                        </ButtonSubscribe>
                      )}
                      {props.pluginSubscriptions.indexOf(
                        (plugin.metadata || plugin.custom_data).pluginType,
                      ) !== -1 && (
                        <ButtonSubscribe
                          onClick={() => {
                            if (
                              props.pluginSubscriptions.indexOf(
                                (plugin.metadata || plugin.custom_data)
                                  .pluginType,
                              ) !== -1
                            ) {
                              if (!isPaddleSubscription) {
                                props.handleOpenCustomerPortal();
                              }
                            }
                          }}
                          value="true"
                          active={
                            props.pluginSubscriptions.indexOf(
                              (plugin.metadata || plugin.custom_data)
                                .pluginType,
                            ) === -1
                          }
                        >
                          {t("form.label.show_active")}
                        </ButtonSubscribe>
                      )}
                      {props.pluginSubscriptions.indexOf(
                        (plugin.metadata || plugin.custom_data).pluginType,
                      ) !== -1 && (
                        <ButtonSubscribe
                          update={true}
                          onClick={() => {
                            setShowManagePluginModal({
                              showManagePluginModal: true,
                            });
                            setPluginForModal(plugin);
                          }}
                        >
                          {t("form.label.manage_plugin")}
                        </ButtonSubscribe>
                      )}
                    </div>
                    {needsPosSetup && (
                      <ButtonSubscribe
                        style={{ width: "245px", marginLeft: "0px" }}
                        onClick={setUpPosShop}
                      >
                        {t("provision.set_up_store", "Set up my store")}
                      </ButtonSubscribe>
                    )}
                    {showPosProgress && <ProvisioningProgress compact />}
                    {pluginType === "STOREFRONT" && isSubscribed && <StorefrontLinks />}
                    {!isPosProvisioning && (
                    <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>
                        {t("form.label.includes")}:
                      </div>
                      <ul
                        style={{
                          paddingLeft: "20px", // Add padding for proper indentation
                          textAlign: "left",
                          fontSize: "0.9em",
                        }}
                      >
                        {t(
                          (plugin.metadata || plugin.custom_data)[
                            `Key_Features`
                          ],
                        )
                          ?.split(/(?:^|\s)-\s/)
                          ?.map((item, index) => {
                            const subItems = item
                              .split("*")
                              .map((subItem) => subItem.trim());
                            if (subItems[0] === "") return null; // Skip empty items
                            return (
                              <li key={index} style={{ marginBottom: "0" }}>
                                {subItems[0]} {/* Render the main item */}
                                {subItems.length > 1 && ( // Check if there are sub-items
                                  <ul
                                    style={{
                                      paddingLeft: "20px",
                                      marginTop: "0",
                                    }}
                                  >
                                    {subItems
                                      .slice(1)
                                      .map((subItem, subIndex) => (
                                        <li
                                          key={subIndex}
                                          style={{ marginBottom: "0" }}
                                        >
                                          {subItem} {/* Render each sub-item */}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                    <div style={{ fontWeight: "bold" }}>
                      {t("form.label.pricing")}:
                    </div>
                    {(() => {
                      // Before buying: the term picked above. After: the
                      // price actually being paid, with its next billing
                      // date — or every price if it cannot be told apart.
                      if (showSubscribeUI) {
                        return selectedPrice ? [selectedPrice] : [];
                      }
                      const paying = prices.filter((price) =>
                        getPluginSubscriptionData(price),
                      );
                      return paying.length ? paying : prices;
                    })().map((price) => (
                      <>
                        <Subtitles price>
                          {!isCAD
                            ? `$ ${(price.unit_price.amount / 100).toFixed(
                                2,
                              )} ${price.unit_price.currency_code.toUpperCase()}`
                            : isCAD
                              ? `$ ${(
                                  price.unit_price_overrides?.filter(
                                    (price) =>
                                      price.country_codes.indexOf("CA") >= 0,
                                  )[0].unit_price.amount / 100
                                ).toFixed(2)} ${price.unit_price_overrides
                                  ?.filter(
                                    (price) =>
                                      price.country_codes.indexOf("CA") >= 0,
                                  )[0]
                                  .unit_price.currency_code.toUpperCase()}`
                              : ""}{" "}
                          /{" "}
                          {t(
                            `form.label.${price.billing_cycle?.interval?.toUpperCase()}`,
                          )}
                        </Subtitles>
                        <Subtitles>
                          <span style={{ fontSize: "0.8em" }}>
                            {getPluginSubscriptionData(price)
                              ? getPluginSubscriptionData(price).next_billed_at
                                ? `${t("form.label.next_billing")}: ${moment(
                                    getPluginSubscriptionData(price)
                                      .next_billed_at,
                                  ).format("DD/MM/YYYY")}`
                                : getPluginSubscriptionData(price)
                                      .current_billing_period
                                  ? `${t("form.label.ends_at")}: ${moment(
                                      getPluginSubscriptionData(price)
                                        .current_billing_period.ends_at,
                                    ).format("DD/MM/YYYY")}`
                                  : `${t("Not Renewable")}`
                              : ""}
                          </span>
                        </Subtitles>
                      </>
                    ))}
                    </>
                    )}
                  </Section>
                </div>
              </SquareHorizontal>
            );
          })
        : props.plugins.map((plugin) => {
            var selectedPrice = null;
            const setSelectedPrice = (price) => {
              selectedPrice = price;
            };
            return (
              <SquareHorizontal>
                <div style={pluginContainerStyle}>
                  <Section key={plugin.id}>
                    <Title>
                      {(plugin.metadata || plugin.custom_data)[`Key_Title`]}
                    </Title>
                    <div style={{ fontSize: "12px", textAlign: "left" }}>
                      {
                        (plugin.metadata || plugin.custom_data)[
                          `Key_Description`
                        ]
                      }
                    </div>
                    {props.pluginSubscriptions.indexOf(
                      (plugin.metadata || plugin.custom_data).pluginType,
                    ) === -1 && (
                      <Select
                        className="arsenal-select"
                        style={dropdownStyle}
                        options={plugin?.prices?.map((price) => ({
                          label: t(
                            `form.label.${price.billing_cycle?.interval?.toUpperCase()}`,
                          ),
                          value: price.id,
                        }))}
                        value={selectedPrice?.id}
                        onChange={(value) => {
                          const selected = plugin?.prices.find(
                            (price) => price.id === value,
                          ); // Find the full price object
                          setSelectedPrice(selected); // Set the full price object
                        }}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentElement
                        }
                      />
                    )}
                    {props.pluginSubscriptions.indexOf(
                      (plugin.metadata || plugin.custom_data).pluginType,
                    ) === -1 && (
                      <ButtonSubscribe
                        onClick={() => {
                          if (
                            props.pluginSubscriptions.indexOf(
                              (plugin.metadata || plugin.custom_data)
                                .pluginType,
                            ) === -1
                          ) {
                            setPluginType(
                              (plugin.metadata || plugin.custom_data)
                                .pluginType,
                            );
                            setPriceId(plugin.default_price);
                            setShowSubscribePluginModal(true);
                          }
                        }}
                        value="true"
                        active={
                          props.pluginSubscriptions.indexOf(
                            (plugin.metadata || plugin.custom_data).pluginType,
                          ) === -1
                        }
                      >
                        {t("form.setting.add_subscription")}
                      </ButtonSubscribe>
                    )}

                    {props.pluginSubscriptions.indexOf(
                      (plugin.metadata || plugin.custom_data).pluginType,
                    ) !== -1 && (
                      <ButtonSubscribe
                        onClick={() => {
                          if (
                            props.pluginSubscriptions.indexOf(
                              (plugin.metadata || plugin.custom_data)
                                .pluginType,
                            ) !== -1
                          ) {
                            if (!isPaddleSubscription) {
                              props.handleOpenCustomerPortal();
                            }
                          }
                        }}
                        value="true"
                        active={
                          props.pluginSubscriptions.indexOf(
                            (plugin.metadata || plugin.custom_data).pluginType,
                          ) === -1
                        }
                      >
                        {t("form.label.show_active")}
                      </ButtonSubscribe>
                    )}
                    {props.pluginSubscriptions.indexOf(
                      (plugin.metadata || plugin.custom_data).pluginType,
                    ) !== -1 && (
                      <ButtonSubscribe
                        update={true}
                        onClick={() => {
                          setShowManagePluginModal({
                            showManagePluginModal: true,
                          });
                          setPluginForModal(plugin);
                        }}
                      >
                        {t("form.label.manage_plugin")}
                      </ButtonSubscribe>
                    )}
                  </Section>

                  <Section>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>
                        {t("form.label.includes")}:
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          alignContent: "flex-start",
                          flexDirection: "column",
                          textAlign: "left",
                          fontSize: "0.9em",
                        }}
                      >
                        {t(
                          (plugin.metadata || plugin.custom_data)[
                            `Key_Features`
                          ],
                        )
                          ?.split(/(?:^|\s)-\s/)
                          ?.map((item, index) => (
                            <div key={index}>- {item.trim()}</div> // Render each part on a new row
                          ))}
                      </div>
                    </div>
                    <div style={{ fontWeight: "bold" }}>
                      {t("form.label.pricing")}:
                    </div>
                    {plugin.prices.map((price) => (
                      <>
                        <Subtitles price>
                          {!isCAD
                            ? `$ ${(price.unit_price.amount / 100).toFixed(
                                2,
                              )} ${price.unit_price.currency_code.toUpperCase()}`
                            : isCAD
                              ? `$ ${(
                                  price.unit_price_overrides?.filter(
                                    (price) =>
                                      price.country_codes.indexOf("CA") >= 0,
                                  )[0].unit_price.amount / 100
                                ).toFixed(2)} ${price.unit_price_overrides
                                  ?.filter(
                                    (price) =>
                                      price.country_codes.indexOf("CA") >= 0,
                                  )[0]
                                  .unit_price.currency_code.toUpperCase()} / ${t(
                                  `form.label.${price.billing_cycle?.interval?.toUpperCase()}`,
                                )}`
                              : ""}{" "}
                          /{" "}
                          {t(
                            `form.label.${price.billing_cycle?.interval?.toUpperCase()}`,
                          )}
                        </Subtitles>
                        <Subtitles>
                          <span style={{ fontSize: "0.8em" }}>
                            {getPluginSubscriptionData(price)
                              ? getPluginSubscriptionData(price).next_billed_at
                                ? `${t("form.label.next_billing")}: ${moment(
                                    getPluginSubscriptionData(price)
                                      .next_billed_at,
                                  ).format("DD/MM/YYYY")}`
                                : getPluginSubscriptionData(price)
                                      .current_billing_period
                                  ? `${t("form.label.ends_at")}: ${moment(
                                      getPluginSubscriptionData(price)
                                        .current_billing_period.ends_at,
                                    ).format("DD/MM/YYYY")}`
                                  : `${t("Not Renewable")}`
                              : ""}
                          </span>
                        </Subtitles>
                      </>
                    ))}
                  </Section>
                </div>
              </SquareHorizontal>
            );
          })}
      <SubscribePluginModal
        show={showSubscribePluginModal}
        onHide={() => {
          setShowSubscribePluginModal(false);
        }}
        onSubscribe={() => {
          setShowSubscribePluginModal(false);
          // The legacy Stripe path goes through the same gate as Paddle:
          // one place where terms are accepted, whichever way the sale runs.
          requireTerms(pluginType, () => {
            props.subscribePlugin({ pluginType, priceId });
          });
        }}
      />
      <TermsGate
        show={showTermsGate}
        moduleCode={termsModuleCode}
        onHide={() => {
          setShowTermsGate(false);
          pendingPurchaseRef.current = null;
        }}
        onAccepted={() => {
          const proceed = pendingPurchaseRef.current;
          pendingPurchaseRef.current = null;
          if (proceed) proceed();
        }}
      />
      <SlugPicker
        show={showSlugPicker}
        onHide={() => setShowSlugPicker(false)}
        onChosen={() => {
          const proceed = pendingSlugRef.current;
          pendingSlugRef.current = null;
          if (proceed) proceed();
        }}
      />
      <ModalManagePlugin plugin={pluginForModal} />
    </PluginGrid>
  );
};

export default connect(
  (state) => {
    return {
      plugins: state.plugin.plugins,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      pluginSubscriptionsData: state.plugin.pluginSubscriptionsData,
      language: state.settings.language,
      loading: state.plugin.loading,
      isPaddleSubscription: state.userSession.isPaddleSubscription,
      customerId:
        state.userSession.subscriptionInfo.customer ||
        state.userSession.subscriptionInfo.customer_id,
      address_id: state.userSession.subscriptionInfo.address_id,
      isCAD: state.userSession.isCAD,
      isSandbox: state.userSession.isSandbox,
      spectreUserId: state.userSession.userData?.id,
      locale: state.settings.language,
      updating: state.plugin.updating,
      canceling: state.plugin.canceling,
      initialValues: state.settings.appSettings,
      provisioning: state.plugin.provisioning,
      provisionStatus: state.plugin.provisionStatus,
      provisionBackend: state.plugin.provisionBackend,
      posApiUrl: state.plugin.plugin_settings?.api_url || null,
      proshopAddress: state.userSession.proshop?.address || "",
      proshopCity: state.userSession.proshop?.city || "",
      proshopState: state.userSession.proshop?.state || "",
      proshopPostalCode: state.userSession.proshop?.postal_code || "",
      proshopCountry: state.userSession.proshop?.country || "",
    };
  },
  {
    getPlugins,
    getPluginSubscriptions,
    subscribePlugin,
    handleOpenCustomerPortal,
    updatePaymentMethodSubscription,
    updatePaymentMethodSubscriptionDone,
    cancelPluginSubscription,
    settingsHandleForm,
    setShowManagePluginModal,
    provisionSpectrePOS,
  },
)(PluginList);
